import { render, staticRenderFns } from "./FacetPane.vue?vue&type=template&id=12d7c77d&"
import script from "./FacetPane.vue?vue&type=script&lang=js&"
export * from "./FacetPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports